/**
 * function to save querystring into session storage.
 */
export function initSaveQueryParamsToSessionStorage() {
	const currentParams = window.modUtils.getUrlParamsToObject();
	if (currentParams && Object.keys(currentParams).length && window.sessionStorage && !window.modForm.opts.ignoreQueryParamsInSessionStorage) {
		window.sessionStorage.setItem('queryParams', JSON.stringify(currentParams));
	}
}
